/**
 * Scroll to Sessions Button
 * Shows/hides button based on #sidebar visibility
 */
(function () {
  const button = document.querySelector(".rd-camp-scroll-to-sessions");
  const sidebar = document.getElementById("sidebar");

  if (!button || !sidebar) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // If sidebar is visible, hide button (data-visible="false")
        // If sidebar is not visible, show button (data-visible="true")
        button.dataset.visible = entry.isIntersecting ? "false" : "true";
      });
    },
    {
      threshold: 0,
      rootMargin: "0px",
    }
  );

  observer.observe(sidebar);
})();
